module.exports = __webpack_public_path__ + "img/yufukuan.81ce07e5.png";